<template>
    <div class="tile is-ancestor audit-detail-box audit-common-box">
        <div class="tile is-parent is-9 audit-view-box">
            <article class="tile is-child box" v-loading="loading" element-loading-text="拼命加载中">
                <div class="audit-panel audit-header-box">
                    <el-row :gutter="10">
                        <el-col :xs="12" :sm="5" :md="5" :lg="5">
                            <label class="detail-tip">章节ID:</label>
                            <span v-text="detailData.content_id"></span>
                        </el-col>
                        <el-col :xs="12" :sm="5" :md="5" :lg="5">
                            <label class="detail-tip">书籍名称:</label>
                            <span v-text="detailData.book_name"></span>
                        </el-col>
                        <el-col :xs="12" :sm="5" :md="5" :lg="5">
                            <label class="detail-tip">书籍作者:</label>
                            <span v-text="detailData.member_name"></span>
                        </el-col>
                        <el-col :xs="12" :sm="5" :md="5" :lg="5">
                            <label class="detail-tip">章节字数:</label>
                            <span v-text="detailData.content_length"></span>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="12" :sm="9" :md="5" :lg="5">
                            <label class="detail-tip">投稿时间:</label>
                            <span v-text="detailData.create_time"></span>
                        </el-col>
                        <el-col :xs="12" :sm="5" :md="5" :lg="5">
                            <label class="detail-tip">投诉内容:</label>
                            <span v-text="detailData.complaint_name"></span>
                        </el-col>
                    </el-row>
                </div>
                <!-- 队列类型标签高亮 -->
                <div class="audit-panel audit-header-box">
                    <el-row>
                        <el-tag v-show="queue_level == 1">高热召回</el-tag>
                        <el-tag v-show="queue_level == 2">用户投诉召回</el-tag>
                    </el-row>
                </div>
                <div class="info">
                    <div class="info-detail-tip audit-top-header">
                        <label class="detail-tip">章节标题:{{ detailData.content_title }}</label>
                    </div>
                    <div class="info-detail-tip">
                        <label class="">内容：</label>
                        <div class="audit-content-box">
                            <div
                                class="J-html-content"
                                v-html="detailData.detail"
                                :class="{ 'phone-view': filter.phoneView === 'phone' }"
                            ></div>
                        </div>
                    </div>
                </div>
            </article>
        </div>
        <div class="tile is-parent is-3 audit-control-box">
            <article class="tile is-child box">
                <!-- 特征检测 -->
                <div class="feature">
                    <h2>特征检测：</h2>
                    <div class="feature-items" :class="Object.keys(machineReason).length ? 'feature-border-red' : ''">
                        <p v-for="text in machineReason" :key="text">{{ text }}</p>
                    </div>
                </div>
                <div class="audit-panel">
                    <!--<div class="audit-panel-title"></div>-->
                    <a href="/audit/rules" target="_blank"
                        ><el-button type="primary" class="audit-button-item">评判标准</el-button></a
                    >
                </div>
                <reject-reason ref="rejectReason" :form="form" :config="config" @handleChecked="handleChecked">
                </reject-reason>
                <div class="ft-controls ">
                    <div class="audit-button-list">
                        <!-- <el-button type="primary" class="audit-button-item" @click="denyAudit" :disabled="disabled"
                            >驳回并进入下一条
                        </el-button> -->
                        <el-button
                            type="primary"
                            class="audit-button-item"
                            @click="resetAudit"
                            :disabled="disabled"
                            v-shortkey="shortkey.miduReset"
                            >重置{{ shortkey.miduReset[0].toUpperCase() }}
                        </el-button>
                        <el-button
                            type="primary"
                            class="audit-button-item"
                            @click="denyAudit"
                            :disabled="disabled"
                            v-shortkey="shortkey.miduPass"
                            >提交并进入下一条{{ shortkey.miduPass[0].toUpperCase() }}
                        </el-button>
                        <el-button
                            :plain="true"
                            type="primary"
                            class="audit-button-item"
                            v-shortkey="shortkey.miduQuit"
                            @click="backAudit({}, 'reviewAudit')"
                            >退出审核{{ shortkey.miduQuit[0].toUpperCase() }}
                        </el-button>
                    </div>
                </div>
            </article>
        </div>
    </div>
</template>

<script>
import auditMixin from '@/common/mixin/auditMixin';
import RejectReason from '@/common/widget/RejectReason.vue';
import dateFormat from '@/common/js/DateFormat';
import QuRequest from '@/core/QuRequest';
import sensitivityCheck from '@/module/SensitivityCheck';
import fixedTableMixin from '@/common/mixin/fixedTableMixin';
import auditConfig from '@/module/AuditConfig';
const shortKey = auditConfig.shortKey;

const quRequest = new QuRequest();

const defaultDetailData = {
    content_id: '',
    book_name: '',
    member_name: '',
    content_length: '',
    create_time: '',
    content_title: '',
    detail: '',
    complaint_name: ''
};

export default {
    mixins: [fixedTableMixin, auditMixin],
    components: {
        RejectReason
    },
    data () {
        return {
            shortkey: shortKey,
            filter: {
                product_key: 'midu',
                app_key: 'story',
                book_id: this.$route.query.book_id || '',
                content_id: this.$route.query.id || '',
                order: this.$route.query.order || '',
                queue_level: this.$route.query.queue_level || 1,
                create_time_start: this.$route.query.create_time_start || dateFormat(-7),
                create_time_end: this.$route.query.create_time_end || dateFormat()
            },
            form: {
                politics: '',
                pornographic: '',
                violence: '',
                violate: [],
                advert: [],
                qualitative: [],
                note: '',
                checkList: []
            },
            detailData: Object.assign({}, defaultDetailData),
            rejectReason: {},
            machineReason: [], // 特征检查
            loading: false,
            disabled: true,
            queue_level: '',
            config: {}
        };
    },
    methods: {
        doAudit (formData) {
            let that = this;
            quRequest
                .send(quRequest.Apis.audit.contentreviewaudit.audit, formData)
                .then(res => {
                    if (res.code === 0) {
                        this.$message.success('审核成功！');
                        this.resetAudit();
                        this.getView({
                            product_key: this.filter.product_key,
                            app_key: this.filter.app_key,
                            book_id: this.filter.book_id,
                            order: this.filter.order,
                            queue_level: this.filter.queue_level,
                            create_time_start: this.filter.create_time_start,
                            create_time_end: this.filter.create_time_end
                        });
                        document.getElementsByClassName('content-container')[0].scrollTop = 0;
                    }
                })
                .catch(res => {
                    that.errorMsg(res);
                })
                .fin(() => {});
        },
        valiobjectKeyIsEmpty (obj) {
            let empty = null;
            for (const key in obj) {
                if (obj.hasOwnProperty(key) && key != 'note') {
                    if (obj[key] === null || obj[key] === '' || (Array.isArray(obj[key]) && obj[key].length < 1)) {
                        empty = true;
                    } else if (Object.keys(obj[key]).length > 0) {
                        Object.values(obj[key]).map(item => {
                            if (Array.isArray(item) && item.length < 1) {
                                empty = true;
                            }
                        });
                    } else {
                        empty = false;
                        break;
                    }
                }
            }
            return empty;
        },
        denyAudit () {
            // let verify = this.valiobjectKeyIsEmpty(this.form);
            // if (verify) {
            //     this.$message.error('请选择驳回原因');
            //     return false;
            // }
            this.$confirm('确认要提交此操作吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    let params = {
                        product: 'midu',
                        appKey: 'story',
                        contentId: this.filter.content_id,
                        politics: [],
                        pornographic: [],
                        violence: [],
                        violate: [],
                        advert: [],
                        // action: 2, // 驳回
                        remark: this.form.note
                    };
                    for (let l in this.form.checkList) {
                        let item = this.form.checkList[l];
                        if (item == 11 || item == 12 || item == 13 || item == 14) {
                            if (!this.form.pornographic[item].length) {
                                return this.$message.error(`请选择涉黄具体原因！`);
                            }
                            params.pornographic.push({
                                k: item,
                                detail: this.form.pornographic[item].sort()
                            });
                        }
                        if (item == 21 || item == 22) {
                            if (!this.form.politics[item].length) {
                                return this.$message.error(`请选择涉政具体原因！`);
                            }
                            params.politics.push({
                                k: item,
                                detail: this.form.politics[item].sort()
                            });
                        }
                        if (item == 31 || item == 32) {
                            if (!this.form.violence[item].length) {
                                return this.$message.error(`请选择暴恐具体原因！`);
                            }
                            params.violence.push({
                                k: item,
                                detail: this.form.violence[item].sort()
                            });
                        }
                        if (item == 41) {
                            if (!this.form.violate[item].length) {
                                return this.$message.error(`请选择违禁具体原因！`);
                            }
                            params.violate.push({
                                k: item,
                                detail: this.form.violate[item].sort()
                            });
                        }
                        if (item == 51) {
                            if (!this.form.advert[item].length) {
                                return this.$message.error(`请选择广告具体原因！`);
                            }
                            params.advert.push({
                                k: item,
                                detail: this.form.advert[item].sort()
                            });
                        }
                    }
                    params.politics = params.politics.length ? JSON.stringify(params.politics) : '';
                    params.pornographic = params.pornographic.length ? JSON.stringify(params.pornographic) : '';
                    params.violence = params.violence.length ? JSON.stringify(params.violence) : '';
                    params.violate = params.violate.length ? JSON.stringify(params.violate) : '';
                    params.advert = params.advert.length ? JSON.stringify(params.advert) : '';
                    // let arr = [];
                    // for (const i in this.form) {
                    //     if (i != 'note') {
                    //         if (Array.isArray(this.form[i])) {
                    //             if (this.form[i].length) {
                    //                 arr.push(this.form[i].join());
                    //             }
                    //         } else if (this.form[i]) {
                    //             arr.push(this.form[i]);
                    //         }
                    //     }
                    // }
                    // param.reason = arr.join();
                    this.doAudit(params);
                })
                .catch(() => {});
        },
        submitAudit () {
            let verify = this.valiobjectKeyIsEmpty(this.form);
            if (!verify) {
                this.$message.error('审核通过时，禁止选择驳回原因！');
                return false;
            }
            this.$confirm('确认要提交此操作吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    let param = {
                        product: 'midu',
                        appKey: 'story',
                        contentId: this.filter.content_id,
                        remark: this.form.note,
                        action: 1 // 通过
                    };
                    let arr = [];
                    for (const i in this.form) {
                        if (i != 'note') {
                            if (Array.isArray(this.form[i])) {
                                if (this.form[i].length) {
                                    arr.push(this.form[i].join());
                                }
                            } else if (this.form[i]) {
                                arr.push(this.form[i]);
                            }
                        }
                    }
                    param.reason = arr.join();
                    this.doAudit(param);
                })
                .catch(() => {});
        },
        handleChecked (k, f) {
            console.log(k);
            let ind = this.form.checkList.indexOf(k);
            if (ind > -1 && this.form[f][k].length < 1) {
                this.form.checkList.splice(ind, 1);
            }
            if (ind < 0) {
                this.form.checkList.push(k);
            }
            console.log(this.form.checkList);
        },
        async getConfig () {
            quRequest
                .send(quRequest.Apis.audit.contentreviewaudit.config, { product: 'midu', appKey: 'story' })
                .then(config => {
                    this.config = config.data;
                    this.getView(this.filter);
                })
                .catch(err => {
                    this.$message.error(`获取失败: ${err.message}`);
                    throw err;
                });
        },
        resetAudit () {
            Object.assign(this.form, {
                politics: {},
                pornographic: {},
                violence: {},
                violate: {},
                advert: {},
                qualitative: '',
                note: '',
                checkList: []
            });
            Object.values(this.config.politics).length &&
                Object.values(this.config.politics).map(item => {
                    this.$set(this.form.politics, item.k, []);
                });
            Object.values(this.config.pornographic).length &&
                Object.values(this.config.pornographic).map(item => {
                    this.$set(this.form.pornographic, item.k, []);
                });
            Object.values(this.config.violence).length &&
                Object.values(this.config.violence).map(item => {
                    this.$set(this.form.violence, item.k, []);
                });
            Object.values(this.config.violate).length &&
                Object.values(this.config.violate).map(item => {
                    this.$set(this.form.violate, item.k, []);
                });
            Object.values(this.config.advert).length &&
                Object.values(this.config.advert).map(item => {
                    this.$set(this.form.advert, item.k, []);
                });
        },
        getView (param) {
            let that = this;
            that.loading = true;
            that.disabled = true;
            this.resetAudit();
            this.nativeView(param)
                .then(data => {
                    let detail = data.content;
                    this.filter.content_id = data.content_id;
                    this.$updateRouter(this.filter);
                    this.queue_level = data.queue_level;
                    // 机审结果
                    let machineAuditResult = data.machine_audit_result;
                    // 没有结果把默认数组转对象
                    if (machineAuditResult && Object.keys(machineAuditResult).length) {
                        // 内容机审字段
                        let detailResult =
                            (machineAuditResult.strategy_content_sensitive &&
                                machineAuditResult.strategy_content_sensitive.result) ||
                            [];
                        // 内容机审字段
                        if (detailResult) {
                            detail = sensitivityCheck.highWord(detail, [...detailResult]);
                            // detail = sensitivityCheck.highContentWord(detail, detailResult)
                        }
                    } else {
                        data.machine_audit_result = {};
                    }

                    data.detail = sensitivityCheck.unDeckContent(detail);

                    // 标签
                    // that.getTagName(data.tags)

                    that.detailData = data;
                    // 特征检测
                    that.machineCheckReason();
                    // 显示按钮
                    that.disabled = false;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        machineCheckReason () {
            // 处理问题提示
            let every = [];
            let machineAuditResult = this.detailData.machine_audit_result;
            for (let key in machineAuditResult) {
                let errorItem = machineAuditResult[key] || [];
                let result = errorItem.result || [];
                switch (key) {
                case 'strategy_article_junk': // 文章内容黄暴恐
                    for (let s = 0; s < result.length; s++) {
                        let item = result[s];
                        // 文章内容图片黄暴恐
                        if (item.suggestion && item.suggestion != 'pass') {
                            every.push(errorItem.name);
                            break;
                        }
                    }
                    break;
                default:
                    break;
                }
            }
            this.machineReason = every;
        }
    },

    mounted () {
        this.getConfig();
    }
};
</script>

<style lang="less">
@import '../../assets/css/auditCommon.less';
.audit-detail-box {
    .feature {
        margin: 0 auto;
    }
    //特征检查
    .feature-items {
        min-height: 60px;
        max-height: 80px;
        position: relative;
        padding: 3px;
        background-color: #fff;
        border: 1px solid #18bda5;
        border-radius: 5px;
        font-size: 13px;
        overflow-y: auto;
    }
}
</style>
